import { AxiosInstance } from 'axios';
import { ClaimUserPasswordResetInput, CreateUserPasswordResetInput } from './inputs';
import { UserPasswordResetRef } from './refs';

export default class UserPasswordReset {
    private basePath = '/api/user-password-reset';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Create new user password reset
    create = async (input: CreateUserPasswordResetInput): Promise<UserPasswordResetRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);
        return data;
    };

    // Claim user password reset and update password
    claim = async (id: ID, input: ClaimUserPasswordResetInput): Promise<UserPasswordResetRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/claim`, input);
        return data;
    };
}
